module.exports = __webpack_public_path__ + "static/media/pf.9fcb9eea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/pf.png
// module id = 1953
// module chunks = 0